import { apiPost } from "../shared/apiClient";

// Raw page fetch — useWatiChatList.js owns pagination/filtering state
// (continuation tokens, date-range scans, large-list warnings) on top of
// this; this only wraps the request/response shape.
export function fetchChatListPage(payload) {
  return apiPost("/wati_messages/fetch_messages_v2", payload)
    .then(res => {
      if (!res.data?.success) return { list: [], token: null, count: null, success: false };
      const data = res.data.data || {};
      return { list: data.final_data || [], token: data.continuationToken || null, count: data.count ?? null, success: true };
    })
    .catch(() => ({ list: [], token: null, count: null, success: false }));
}

// The ad-hoc "find this customer's chat by phone" payload, hand-duplicated
// across QuerysetV4, EditDraftDrawer, WorkflowTaskDrawer, MoveForwardModal,
// and SendPdfModal — all reuse fetch_messages_v2 with filterType 0 and no
// subConditions, keyed purely by searchString.
export function buildPhoneSearchPayload(userId, phone) {
  return { userId, continuationToken: "", filterType: 0, subConditions: null, searchString: phone, searchOptionType: 0 };
}

export function searchChatByPhone(userId, phone) {
  return fetchChatListPage(buildPhoneSearchPayload(userId, phone));
}
